import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 relative overflow-hidden bg-slate-50">
      {/* Subtle Background Elements */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-indigo-50 rounded-full blur-[100px] -z-10 translate-x-1/3 -translate-y-1/3"></div>
      
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="order-2 lg:order-1"
          >
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 leading-[1.2]">
              Empowering the <br/>
              <span className="text-gradient">Digital Economy</span>
            </h2>
            <div className="space-y-6 text-lg text-slate-600">
              <p>
                At Digital Ways, our mission is to simplify complex digital workflows. Whether it's securely sharing massive files, protecting eCommerce margins, or hosting images globally, we build tools that just work.
              </p>
              <p>
                Our vision is to become the underlying infrastructure for everyday digital interactions. We believe in creating clean, fast, and reliable software that empowers users rather than gets in their way.
              </p>
            </div>
            
            <div className="mt-10 flex flex-wrap gap-4">
              <div className="px-6 py-4 rounded-2xl bg-white border border-slate-200 shadow-sm flex-1 min-w-[140px]">
                <div className="text-3xl font-bold text-slate-900 mb-1">2012</div>
                <div className="text-sm font-semibold text-slate-500 uppercase tracking-wider">Founded</div>
              </div>
              <div className="px-6 py-4 rounded-2xl bg-white border border-slate-200 shadow-sm flex-1 min-w-[140px]">
                <div className="text-3xl font-bold text-slate-900 mb-1">Global</div>
                <div className="text-sm font-semibold text-slate-500 uppercase tracking-wider">Reach</div>
              </div>
            </div>
          </motion.div>
          
          {/* Quote Section */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-full relative flex justify-center py-10 order-1 lg:order-2"
          >
            {/* Spinning decorative circles - Fixed bounds */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] md:w-[450px] md:h-[450px] flex items-center justify-center -z-10 pointer-events-none">
              <div className="absolute w-[90%] h-[90%] rounded-full border border-indigo-100 border-dashed animate-spin-slow"></div>
              <div className="absolute w-[70%] h-[70%] rounded-full border border-purple-100 animate-[spin_20s_linear_infinite_reverse]"></div>
            </div>
            
            {/* Quote Card */}
            <div className="glass-card rounded-3xl p-8 md:p-12 w-full max-w-[400px] relative z-10 text-center shadow-xl shadow-indigo-900/5 bg-white/95 border border-slate-100">
               <div className="text-6xl md:text-8xl font-black text-slate-100/60 absolute -top-4 right-6 -z-10 select-none">DW</div>
               <SafeIcon name="Quote" className="text-4xl text-indigo-400 mx-auto mb-6 relative z-20" />
               <p className="text-xl md:text-2xl font-semibold text-slate-800 leading-relaxed relative z-20">
                 "Technology should solve problems silently, reliably, and beautifully."
               </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;